import * as React from 'react';

import { BoxProps } from '../box';
import { Adaptive } from '../../styles';
import { Root } from './styled';


export type CardProps = {
	appearance?: 'paper' | 'repeater-item';
	isActive?: boolean;
	elevation?: number;
	hoverElevation?: number;
	beyondContainerWhenActive?: boolean;
	bg?: 'white' | 'stealthy';
} & Adaptive & BoxProps;

const Card: React.SFC<CardProps> = (props) => {
	const {
		appearance,
		elevation,
		hoverElevation,
		children,
		...rest
	} = props;
	const dynamicProps = {
		'elevation': appearance === 'paper' && typeof elevation === 'undefined' ? 1 : elevation,
		'hoverElevation': appearance === 'repeater-item' && typeof hoverElevation === 'undefined' ? 3 : hoverElevation,
	};

	return (
		<Root
			appearance={appearance}
			{...rest}
			{...dynamicProps}>{children}</Root>
	);
}

Card.displayName = 'Card';
Card.defaultProps = {
	appearance: 'paper',
	bg: 'white',
	padding: 16
};

export default Card;
